import { useCallback, useState } from "react";
import { YMapsApi } from "react-yandex-maps";

export const useYMaps = () => {
  const [mapApi, setMapApi] = useState<YMapsApi | null>(null);
  const template = useCallback(
    (color: string, status: string) => {
      if (mapApi) {
        const template = mapApi.templateLayoutFactory.createClass(
          `<div class="placeMarker ${status}" style="font-size: 12px;font-weight: 700; margin: 0 auto;">{{properties.iconContent}} </div>`
        );
        return template;
      }
    },
    [mapApi]
  );
  return { mapApi, setMapApi, template };
};
